import React from 'react';
import { SvgProps } from 'apps/sigma2-ui/src/components/svg/types';
import { toSvgColor } from 'apps/sigma2-ui/src/components/svg/types';

export const CodeIconGroup: React.FC<SvgProps> = (props) => {
  const strokeColor = toSvgColor('currentColor', props);
  return (
    <g fill="none" {...(props.group ?? {})}>
      <g clipPath="url(#clip0_14619_273761)">
        <path
          d="M14.3438 13.8926C14.3438 14.1329 14.2483 14.3634 14.0783 14.5334C13.9084 14.7033 13.6779 14.7988 13.4375 14.7988H2.5625C2.32215 14.7988 2.09164 14.7033 1.92168 14.5334C1.75173 14.3634 1.65625 14.1329 1.65625 13.8926V2.11133C1.65625 1.87098 1.75173 1.64047 1.92168 1.47051C2.09164 1.30056 2.32215 1.20508 2.5625 1.20508H11.6522C11.8888 1.20511 12.1161 1.2977 12.2854 1.46306L14.0707 3.20427C14.1572 3.28874 14.2259 3.38966 14.2728 3.5011C14.3197 3.61254 14.3438 3.73224 14.3438 3.85314V13.8926Z"
          stroke={strokeColor}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.38672 6.18945L11.6523 8.45508L9.38672 10.7207"
          stroke={strokeColor}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.66797 6.18945L4.40234 8.45508L6.66797 10.7207"
          stroke={strokeColor}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_14619_273761">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </g>
  );
};

export const CodeIconSvg: React.FC<SvgProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      {...(props.svg ?? {})}
    >
      <CodeIconGroup {...props} />
    </svg>
  );
};
